module.exports = __webpack_public_path__ + "media/images/icons/outlined/zoom-in-8e1da8a32aa68df03346d876d7ecbfbf.svg";